"use client";

import { useEffect } from "react";
import { display, ui } from "./fonts";
// global-error.tsx REPLACES the root layout when it fires, so the layout's
// stylesheet and font classNames do not ship with it. Import and re-apply
// (the faces come from ./fonts, shared with the layout).
import "./globals.css";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    void (async () => {
      try {
        const { reportError } = await import("@/lib/flare");
        await reportError(error, { kind: "client", digest: error.digest });
      } catch {
        // The page is already broken; a failed report must not make it worse.
      }
    })();
  }, [error]);

  return (
    <html lang="en" className={`${display.variable} ${ui.variable}`}>
      <head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="color-scheme" content="light" />
        <title>Toile stopped working</title>
      </head>
      <body style={{ background: "#f9cfe0" }}>
        <main className="error-page">
          <div className="card error-card">
            <div className="cut error-inner">
              <h1 className="wavy">Something tore. Try again.</h1>
              <div className="error-actions">
                <button type="button" className="btn" onClick={reset}>Try again</button>
              </div>
              {error.digest && <p className="error-digest">{error.digest}</p>}
            </div>
          </div>
        </main>
      </body>
    </html>
  );
}
